<script>
import {certifyList, deleteCertify, enableCertify, postCertify, putCertify} from "@/api/certify";
import {categoryInfo, uploadCert} from "@/api";
import {Message} from "element-ui";
import {formatDate} from "@/utils/data";

export default {
  name: 'TemplateCertify',
  data() {
    return {
      // 分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0,
      certifyList: [],
      visible: false,
      certify: {},
      timeRange: [],
      deviceequipmentTypes: [],
      uploadFiles: [],
      submitLoading: false,
      fileList: [],
      objectIdQuery: null,
    }
  },
  mounted() {
    this.categoryList();
    this.fetchCertifyList();
  },
  methods: {
    // 为表格行添加交替样式
    tableRowClassName({row, rowIndex}) {
      return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
    },

    //设备类型接口
    async categoryList() {
      try {
        const param = {
          current : 1,
          size : 1000
        }
        const res = await categoryInfo(param);
        this.deviceequipmentTypes = res.result.records;
        // 如果类型不一致（比如一个是数字，一个是字符串），统一类型
        this.deviceequipmentTypes = this.deviceequipmentTypes.map(item => ({
          ...item,
          id: String(item.id) // 统一转为字符串（或Number，看device.categooryId类型）
        }));
      } catch (error) {
        console.error('获取模板类型失败：', error);
        this.$message.error('加载模板类型失败，请重试');
      }
    },

    openEditDrawer() {
      if (this.certify.id) {
        this.certify = {}
      }
      this.visible = !this.visible;
    },

    async fetchCertifyList() {
      try {
        const params = {
          current: this.currentPage,
          size: this.pageSize,
          filter: [{
            name: 'certifyType',
            type: 'EQ',
            value: 'TEMPLATE'
          }],
          sorted: [{
            name: 'createTime',
            type: 'DESC'
          }]
        }
        if (this.objectIdQuery) {
          params.filter.push({
            name: 'objectId',
            type: 'EQ',
            value: this.objectIdQuery
          })
        }

        const resp = await certifyList(params);
        this.certifyList = resp.result.records || [];
        this.total = resp.result.total;
      } catch (e) {
        console.log(e)
        this.certifyList = []; // 确保有默认空数组
      }
    },


    handleRemove(file, fileList) {
      this.fileList.splice(fileList.indexOf(file), 1);
    },
    handlePreview(file) {
      window.open(file.url);
    },
    openFilePreview(path) {
      const prefix = process.env.VUE_APP_FILE_PREFIX;
      const filePath = prefix + path
      return window.open(filePath);
    },

    //上传图片
    async customUpload(params) {
      const formData = new FormData();
      formData.append('file', params.file);  // 关键：将文件添加到 FormData
      try {
        const res = await uploadCert(formData);  // 传入 FormData
        this.uploadFiles.push(res.result)
        console.log("上传成功", res);
        params.onSuccess(res);  // 通知 el-upload 上传成功
      } catch (err) {
        console.error("上传失败", err);
        params.onError(err);  // 通知 el-upload 上传失败
      }
    },

    // 选择设备类型
    handleCategory(data) {
      // this.certify.objectId = data
    },

    handleSizeChange(val) {
      this.pageSize = val;
      // this.currentPage = 1; // 当页面大小改变时，重置到第一页
      this.fetchCertifyList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchCertifyList()
    },


    async submitCertify() {
      if (this.timeRange.length === 0) {
        Message.error('请设置有效期');
        return;
      }
      if (!this.certify.id) {
        if (this.uploadFiles.length === 0 ) {
          Message.error('请上传证书文件');
          return;
        }
        // 新增
        try {
          let param = {
            ...this.certify,
            certifyType: 'TEMPLATE',
            uploadFiles: this.uploadFiles,
            validStart: formatDate(this.timeRange[0], 'yyyy-MM-dd HH:mm:ss'),
            validEnd: formatDate(this.timeRange[1], 'yyyy-MM-dd 23:59:59'),
          }
          console.log('param', param)
          const res = await postCertify(param)
          if (res && res.code === "0000") {
            Message.success('新增证书成功')
          }
        } catch (e) {
          Message.error('新增证书失败')
        }
      } else {
        // 编辑
        if (this.uploadFiles.length === 0 && this.fileList.length === 0) {
          Message.error('请上传证书文件');
          return;
        }

        try {
          let param = {
            id : this.certify.id,
            certifyNo : this.certify.certifyNo,
            certifyName : this.certify.certifyName,
            uploadFiles: this.uploadFiles.length > 0 ? this.uploadFiles : null,
            validStart: formatDate(this.timeRange[0], 'yyyy-MM-dd HH:mm:ss'),
            validEnd: formatDate(this.timeRange[1], 'yyyy-MM-dd 23:59:59'),
          }
          console.log('param', param)
          const res = await putCertify(param)
          if (res && res.code === "0000") {
            Message.success('更新证书成功')
          }
        } catch (e) {
          Message.error('更新证书失败')
        }


      }

      this.cleanCertify();
      this.fetchCertifyList();
      this.$refs.editDrawer.closeDrawer()
    },

    async enableCertify(id) {
      try {
        const res = await enableCertify(id)
        if (res && res.code === "0000") {
          Message.success(`操作成功`)
          this.fetchCertifyList()
        }
      } catch (e) {
        Message.error('操作失败')
      }
    },

    async deleteCertify(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          deleteCertify(id).then( res => {
            if (res && res.code === "0000") {
              Message.success(`删除成功`)
              this.cleanCertify()
              this.fetchCertifyList()
            }
          })
        } catch (e) {
          Message.error('删除失败')
        }
      }).catch(() => {

      });

    },

    validFormat(row,column){
      let value =  row[column.property]
      return value && value.length > 10 ? value.substring(0, 10) : '-';
    },

    handleEdit(item) {
      this.certify = {
        ...item,
        categoryIds: [String(item.objectId)] // 确保与 deviceequipmentTypes 中的 id 类型一致
      }
      this.timeRange = [new Date(item.validStart), new Date(item.validEnd)]
      // 提取文件后缀
      const fileName = item.filePath.substring(item.filePath.lastIndexOf('/') + 1)
      let imgOjb = {
        name: fileName,
        url: process.env.VUE_APP_FILE_PREFIX + item.filePath,
        uid: `edit-${Date.now()}` // 补充唯一标识，避免 el-upload 出现异常
      }
      this.fileList = [imgOjb]
      this.visible = true

    },

    cleanCertify() {
      this.certify = {}
      this.fileList = []
      this.uploadFiles = []
      this.timeRange = []
      this.currentPage = 1
    },

    handleCategoryFilter() {
      this.cleanCertify();
      this.fetchCertifyList()
    },


  },
}
</script>

<template>
  <div>
    <el-card class="main-card">
      <div class="card-header">
        <div style="display: flex; align-items: center; gap: 6px;">
          <div class="filter-bar">
            设备类型：
            <el-select v-model="objectIdQuery" placeholder="筛选设备类型" clearable class="form-select"
                       @change="handleCategoryFilter">
              <el-option v-for="item in deviceequipmentTypes" :key="item.id" :label="item.name"
                         :value="item.id"/>
            </el-select>
          </div>
        </div>
        <el-button type="primary" @click="openEditDrawer">新增配套证书</el-button>
      </div>

      <el-table :data="certifyList" border class="device-table" stripe highlight-current-row
                :row-class-name="tableRowClassName">

        <el-table-column prop="certifyNo" label="证书编号" fixed/>
        <el-table-column prop="certifyName" label="证书名称"/>
        <el-table-column prop="equipmentCategoryName" label="设备类型" />
        <el-table-column prop="validStart" label="发证时间" :formatter="validFormat" />
        <el-table-column prop="validEnd" label="到期时间" :formatter="validFormat" />
        <el-table-column prop="enabled" label="是否启用">
          <template slot-scope="scope">
                <span :style="scope.row.enabled ? 'color: green' : 'color: red' "
                >{{ scope.row.enabled ? '启用' : '禁用' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="filePath" label="文件">
          <template slot-scope="scope">
            <div v-if="scope.row.filePath" style="color: #409eff" @click="openFilePreview(scope.row.filePath)">
              点击查看
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="创建时间" width="200" />
        <el-table-column prop="createTime" label="更新时间" width="200" />

        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="enableCertify(scope.row.id)"
                       :style="scope.row.enabled ? 'color: red' : 'color: green' ">
              {{ scope.row.enabled ? '禁用' : '启用' }}
            </el-button>
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button size="mini" type="text" @click="deleteCertify(scope.row.id)" style="color: red">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"
                       class="pagination"></el-pagination>
      </div>
    </el-card>

    <el-drawer
        :title="certify.id ? '编辑': '新增'"
        :visible.sync="visible"
        direction="rtl"
        ref="editDrawer"
    >
      <div class="edit-container">
        <el-form ref="certifyForm" :model="certify" label-width="100px">
          <el-form-item label="证书编号">
            <el-input v-model="certify.certifyNo" clearable/>
          </el-form-item>
          <el-form-item label="证书名称">
            <el-input v-model="certify.certifyName" clearable/>
          </el-form-item>
          <!-- 设备类型 -->
          <el-form-item label="设备类型" prop="categoryIds">
            <el-select v-model="certify.categoryIds" multiple :disabled="certify.id" placeholder="请选择设备类型"
                       clearable class="form-select"
                       @change="handleCategory">
              <el-option v-for="item in deviceequipmentTypes" :key="item.id" :label="item.name"
                         :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="证书有效期">
            <el-date-picker
                v-model="timeRange"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="发证时间"
                end-placeholder="到期时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="证书文件">
            <el-upload action="" :http-request="customUpload" :on-preview="handlePreview"
                       :on-remove="handleRemove" list-type="text" :limit=" certify.id ? 1 : 6" :file-list="fileList">
              <el-button size="small" type="primary"
                         :disabled="(certify.id && fileList.length === 1) || (!certify.id && fileList.length >= 6)">点击上传
              </el-button>
              <div slot="tip">
                {{ certify.id ? '编辑证书单次仅可操作一个文件' : '单次最多上传6个文件' }}
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="edit-footer">
          <el-button @click="$refs.editDrawer.closeDrawer()">取 消</el-button>
          <el-button type="primary" @click="submitCertify" :loading="submitLoading">
            {{ submitLoading ? '提交中 ...' : '提 交' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>

</template>

<style scoped>

/* 主卡片样式 */
.main-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}


.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.edit-container {
  display: flex;
  flex-direction: column;
  padding: 12px;
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  .edit-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    padding: 12px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.table-row-even {
  background-color: #fff;
}

.table-row-odd {
  background-color: #fafafa;
}

/* 搜索区域 */
.filter-bar {
  display: flex;
  margin: 20px;
  align-items: center;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

}

/* 分页样式 */
.pagination-container {
  margin: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f2f5;
  text-align: right;
}


</style>
